import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import { PrimaryCta } from '../components/CtaSystem';
import servicesData from '../data/servicesData';
import './Services.css';

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="services-page">
      {/* HERO SECTION */}
      <section className="services-hero">
        <video
          className="services-hero-video"
          src={`${process.env.PUBLIC_URL}/herovideo2.mp4`}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="services-hero-overlay" />
        <div className="services-container">
          <motion.div
            className="services-hero-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="services-eyebrow">OUR SERVICES</span>
            <h1 className="services-hero-title">
              Technology and data solutions for modern businesses.
            </h1>
            <p className="services-hero-desc">
              Practical AI, analytics, automation, compliance, and digital solutions designed to help organizations improve accuracy, efficiency, and decision-making.
            </p>
          </motion.div>
        </div>
      </section>

      {/* SERVICES CARD GRID */}
      <section className="services-grid-section">
        <div className="services-container">
          <div className="services-card-grid">
            {servicesData.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <motion.div
                  key={service.slug}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-40px' }}
                  transition={{ duration: 0.45, delay: (index % 4) * 0.08 }}
                >
                  <Link to={service.route} className="services-card">
                    <div className="services-card-top">
                      <span className="services-card-num">{service.num}</span>
                      <span className="services-card-icon">
                        <IconComponent />
                      </span>
                    </div>
                    <h3 className="services-card-title">{service.shortTitle}</h3>
                    <p className="services-card-desc">{service.cardDesc}</p>
                    <span className="services-card-link">
                      Explore Service <FiArrowRight className="services-card-arrow" />
                    </span>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Unified Primary CTA */}
      <PrimaryCta
        eyebrow="READY TO ELEVATE YOUR DATA?"
        heading="Transform Your Data & Compliance Workflows"
        description="Partner with Data Bolta Hai to automate GST reconciliation, optimize bank audit mining, and fortify enterprise security."
        primaryBtnText="Talk to an Expert"
        primaryBtnLink="/contact-us"
        secondaryBtnText="Contact Us"
        secondaryBtnLink="/contact-us"
      />
    </div>
  );
};

export default Services;
